<div class="download-page-container">
  <public-header />

  <div class="main-content">
    <div class="root-container">
      <div class="header-section">
        <h1 class="page-title">Download</h1>
      </div>

      <div class="loading-container" *ngIf="loading()">
        <div class="loading-spinner">
          <div class="spinner"></div>
          <p>Loading files...</p>
          
        </div>
      </div>

      <div class="files-container" *ngIf="!loading()">
        <div class="files-header" *ngIf="filteredFiles.length > 0">
          <h2>Available Files ({{ filteredFiles.length }})</h2>
        </div>

        <div class="files-grid" *ngIf="filteredFiles.length > 0; else noFiles">
          <div class="file-card file-card-actions-bottom" *ngFor="let file of filteredFiles">
            <div class="file-header">
              <div class="file-icon">
                <i [class]="getFileIcon(file.originalName || file.mainFileName) + ' icon'"></i>
              </div>
              <div class="file-info">
                <h3 class="file-title">{{ file.title || file.mainFileName }}</h3>

              </div>
            </div>

            <div class="file-content">
              <p class="file-description" *ngIf="file.description">
                {{ file.description }}
              </p>
              <p class="file-description placeholder" *ngIf="!file.description">
                No description available
              </p>

              <div class="file-details">
                <div class="detail-item" *ngIf="!file.linkUrl">
                  <span class="label">Main File:</span>
                  <span class="value">{{ file.mainFileName }}</span>
                </div>
                <div class="detail-item" *ngIf="file.linkUrl">
                  <span class="label">Link URL:</span>
                  <span class="value link-url">{{ file.linkUrl }}</span>
                </div>
                <div class="detail-item" *ngIf="file.uploadDate">
                  <span class="label">Uploaded:</span>
                  <span class="value">{{ file.uploadDate | date:'mediumDate' }}</span>
                </div>
              </div>              
            </div>

            <div class="file-actions">
              <button 
                class="download-btn primary"
                (click)="downloadFile(file.id, file.originalName || file.mainFileName)"
                [disabled]="!file.id"
                title="Download file"
                *ngIf="!file.linkUrl"
              >
                <span class="pi pi-download"></span>
              </button>
              <button 
                class="download-btn secondary"
                (click)="viewLinkFile(file.linkUrl)"
                [disabled]="!file.linkUrl"
                *ngIf="file.linkUrl"
                title="Open link in new tab"
              >
                <span class="pi pi-sign-in"></span>
              </button>
              <button 
                class="download-btn tertiary"
                (click)="copyToClipboard(file.linkUrl)"
                [disabled]="!file.linkUrl"  
                *ngIf="file.linkUrl"
                title="Copy link to clipboard"
              >
                <span class="pi pi-copy"></span>
              </button>
            </div>
          </div>
        </div>

        <ng-template #noFiles>    
          <div class="no-files">
            <div class="no-files-content">
              <i class="pi pi-spin pi-spinner"></i>
              <h3>No files found</h3>
              <p *ngIf="searchTerm || selectedCategory">
                No files match your current search criteria. Try adjusting your filters.
              </p>
              <p *ngIf="!searchTerm && !selectedCategory">
                No files are currently available
              </p>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>